import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import partial from 'lodash/partial';
import { reqInvite } from 'invite/ducks';
import { fetchInvites } from 'project/ducks/creatives';
import { getProjectIdFromUrl, isEliteWindowOpen, isEliteFull } from 'project/utils';
import { getProject } from 'project/ducks/project';
import Invited from 'project/components/invited';

export function mapStateToProps(state, { params }) {
  const { project: { creatives: { invites } } } = state;
  const project = getProject(state);

  return {
    canInvite: project.status === 'open',
    isEliteWindowClosed: project.elite_only && isEliteFull(state) && !isEliteWindowOpen(state),
    projectId: getProjectIdFromUrl(params),
    invites
  };
}

export function mapDispatchToProps(dispatch, { params }) {
  return bindActionCreators({
    resendInvite: reqInvite,
    fetch: partial(fetchInvites, getProjectIdFromUrl(params))
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Invited));



// WEBPACK FOOTER //
// ./project/containers/invited.js